/**
 * Libraries sub-module catalog.
 * Default landing = first item (alphabetical).
 * Real screens replace ComingSoon section-by-section later.
 */
import {
  BuildingIcon,
  InvoiceIcon,
  MapPinIcon,
  ShieldIcon,
  PillIcon,
  DoctorIcon,
  HelpingIcon,
  PayrollIcon,
  ReceiptIcon,
  MedicalNotesIcon,
  UserCheckIcon,
} from "../../Icons";

export const LIBRARIES_DEFAULT_SECTION = "agencies";

/** Display labels are unique & meaningful; ids/paths stay stable for routes. */
export const LIBRARIES_NAV = [
  {
    id: "agencies",
    label: "Agency Profiles",
    path: "agencies",
    icon: BuildingIcon,
    description: "Tenant agency profiles and settings.",
  },
  {
    id: "facility",
    label: "Care Facilities",
    path: "facility",
    icon: MapPinIcon,
    description: "Facilities and locations used across the tenant.",
  },
  {
    id: "care-plan-templates",
    label: "Care Plan Library",
    path: "care-plan-templates",
    icon: MedicalNotesIcon,
    description: "Plan of Care section templates — eligibility, goals, DME, and more.",
  },
  {
    id: "billing-codes",
    label: "Claim Billing Codes",
    path: "billing-codes",
    icon: ReceiptIcon,
    description: "Billing code catalog for claims and authorizations.",
  },
  {
    id: "cosigners",
    label: "Clinical Cosigners",
    path: "cosigners",
    icon: UserCheckIcon,
    description: "Cosigner directory for clinical form workflows.",
  },
  {
    id: "insurance",
    label: "Insurance Carriers",
    path: "insurance",
    icon: ShieldIcon,
    description: "Insurance / payer master for this tenant.",
  },
  {
    id: "pharmacy",
    label: "Pharmacy Directory",
    path: "pharmacy",
    icon: PillIcon,
    description: "Pharmacy directory for patient medication workflows.",
  },
  {
    id: "physician",
    label: "Physician Directory",
    path: "physician",
    icon: DoctorIcon,
    description: "Physician catalog and PECOS enrollment for this tenant.",
  },
  {
    id: "cpt-code",
    label: "Procedure Codes",
    path: "cpt-code",
    icon: InvoiceIcon,
    description: "CPT / HCPCS code catalog used in billing and orders.",
  },
  {
    id: "referrer",
    label: "Referral Sources",
    path: "referrer",
    icon: HelpingIcon,
    description: "Referral sources used across patient intake for this tenant.",
  },
  {
    id: "payroll-rates",
    label: "Staff Pay Rates",
    path: "payroll-rates",
    icon: PayrollIcon,
    description: "Tenant payroll rate tables by role and discipline.",
  },
];

export function getLibrariesSection(sectionId) {
  return (
    LIBRARIES_NAV.find((item) => item.id === sectionId) || LIBRARIES_NAV[0]
  );
}
